import React from "react";

const Play: React.FC = () => (
<svg xmlns="http://www.w3.org/2000/svg" width="80" height="79" viewBox="0 0 80 79" fill="none">
  <circle cx="40.1567" cy="39.4497" r="38.4497" stroke="white" strokeWidth="2"/>
  <path d="M33.6356 29.0665L52.1992 39.7842L33.6356 50.5019L33.6356 29.0665Z" stroke="white" strokeWidth="2"/>
</svg>
);

export default Play;
